// extracted by mini-css-extract-plugin
export default {"IconButton":"add-column-header-module__IconButton--ZtONQ","DisabledButton":"add-column-header-module__DisabledButton--eLDdd"};